var exports = {
  "common-title-col": "xe7b6e3d6--18d925--common-title-col",
  "common-rate-col": "xe7b6e3d6--18d925--common-rate-col",
  "common-sum-col": "xe7b6e3d6--18d925--common-sum-col",
  "common-term-col": "xe7b6e3d6--18d925--common-term-col",
  "common-payment-col": "xe7b6e3d6--18d925--common-payment-col",
};

module.exports = exports;
